import { useDebugValue } from 'react';
import { useClauseFieldPath } from './useClauseFieldPath';

export const useClauseConditionsFieldPath = () => {
  const clauseFieldPath = useClauseFieldPath();
  const fieldPath = `${clauseFieldPath}.conditions` as const;
  useDebugValue(fieldPath);
  return fieldPath;
};
